import classNames from 'classnames';
import * as Icons from '@/assets/icons/icons';
import styles from './icon.module.scss';

export type IconSize = 8 | 10 | 12 | 14 | 16 | 20 | 24 | 32 | 40 | 48 | 52 | 56;

export interface IconProps {
  /** The class name to apply */
  className?: string;
  /** The name of the icon to show */
  name: IconName;
  /** The size of the icon to show */
  size?: IconSize;
  /** A title to show when hovering the icon */
  title?: string;
}

const Icon = ({ className, name, size = 16, title }: IconProps) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <div className={classNames(styles.component, className)} title={title}>
      <IconComponent
        className={styles.icon}
        height={size}
        preserveAspectRatio="xMidYMid meet"
        width={size}
      />
    </div>
  );
};

Icon.displayName = 'Icon';

export default Icon;
